import { RouterProvider as AtomicRouterProvider } from 'atomic-router-react';
import { PropsWithChildren } from 'react';
import { createComposableProvider } from 'shared/lib';
import { router } from 'shared/routes';

export const RouterProvider = ({ children }: PropsWithChildren) => (
	<AtomicRouterProvider router={router}>{children}</AtomicRouterProvider>
);

export const withRouter = createComposableProvider(RouterProvider);
